export default __webpack_public_path__ + "static/media/detail_big_10_8.8bb03a12.jpg";